var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,1.5C6.2,1.5,1.5,6.2,1.5,12S6.2,22.5,12,22.5S22.5,17.8,22.5,12S17.8,1.5,12,1.5z M2.5,12c0-5.2,4.3-9.5,9.5-9.5 s9.5,4.3,9.5,9.5c0,2.2-0.8,4.3-2.1,5.9C19,15,17,12.7,14.2,11.8c1.1-0.7,1.8-1.9,1.8-3.3c0-2.2-1.8-4-4-4s-4,1.8-4,4 c0,1.4,0.7,2.6,1.8,3.3C7,12.7,5,15,4.6,17.9C3.3,16.3,2.5,14.2,2.5,12z M12,11.5c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3 S13.7,11.5,12,11.5z M5.5,18.9c0-3.6,2.9-6.4,6.5-6.4s6.5,2.9,6.5,6.4c-1.7,1.6-4,2.6-6.5,2.6S7.2,20.5,5.5,18.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogin);
export default __webpack_public_path__ + "static/media/icon-login.5e65272df021cbfd3fbc52dfac9d256e.svg";
export { ForwardRef as ReactComponent };